import { UNGROUPED_RESOURCES_GROUP_ID } from '@/shared/features/groups/components/group-list/group-list.constants';
import { TPermissionAction } from '@/shared/features/permissions/actions';
import { usePermissionCheck } from '@/shared/features/permissions/hooks/use-permission-check/use-permission-check';
import { TPermissionCheckRule } from '@/shared/features/permissions/permission-check.types';
import { ResourceGroupFragment } from '@/shared/types/types.generated';

export type TUseGroupScopedCreateParams = {
  action: TPermissionAction;
  groupId?: string | null;
};

export type TGroupScopedCreateSelectProps = {
  required: boolean;
  showNoGroupOption: boolean;
  groupFilter: (group: ResourceGroupFragment) => boolean;
};

export const normalizeGroupScopedCreateId = (groupId?: string | null) => {
  if (!groupId || groupId === UNGROUPED_RESOURCES_GROUP_ID) {
    return undefined;
  }

  return groupId;
};

export const useGroupScopedCreate = ({
  action,
  groupId,
}: TUseGroupScopedCreateParams) => {
  const { can } = usePermissionCheck();
  const normalizedGroupId = normalizeGroupScopedCreateId(groupId);
  const canCreateAtRoot = can(action, '*');
  const requiresGroup = !canCreateAtRoot;
  const permission: TPermissionCheckRule = normalizedGroupId
    ? { action, ids: normalizedGroupId }
    : { action };

  return {
    groupId: normalizedGroupId,
    canCreateAtRoot,
    requiresGroup,
    permission,
    groupSelectProps: {
      required: requiresGroup,
      showNoGroupOption: !requiresGroup,
      groupFilter: (group: ResourceGroupFragment) =>
        !requiresGroup || can(action, group.groupId),
    },
  };
};
